import { render } from "./ImgFooter.vue?vue&type=template&id=792d46f7&scoped=true"
import script from "./ImgFooter.vue?vue&type=script&lang=js"
export * from "./ImgFooter.vue?vue&type=script&lang=js"

import "./ImgFooter.vue?vue&type=style&index=0&id=792d46f7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792d46f7"]])

export default __exports__